(() => {
  const init = () => {
    const root = document.querySelector('[data-mlx]');
    if (!root) return;

    const panels = [...root.querySelectorAll('[data-mlx-panel]')];
    const pins = [...root.querySelectorAll('[data-mlx-story]')];
    pins.forEach(pin => pin.addEventListener('click', () => {
      const key = pin.dataset.mlxStory;
      pins.forEach(p => p.classList.toggle('is-active', p === pin));
      panels.forEach(panel => {
        const active = panel.dataset.mlxPanel === key;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      const panelWrap = root.querySelector('[data-mlx-map-panels]');
      if (window.innerWidth < 750 && panelWrap) panelWrap.scrollIntoView({behavior:'smooth', block:'nearest'});
    }));

    const reveal = [...root.querySelectorAll('[data-mlx-reveal]')];
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, {threshold:.12, rootMargin:'0px 0px -40px'});
      reveal.forEach(el => revealObserver.observe(el));
    } else reveal.forEach(el => el.classList.add('is-visible'));
    window.setTimeout(() => reveal.forEach(el => el.classList.add('is-visible')), 1800);

    const counter = root.querySelector('[data-mlx-count]');
    if (counter) {
      const target = Number(counter.dataset.mlxCount || 55);
      let counted = false;
      const runCounter = () => {
        if (counted) return;
        counted = true;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { counter.textContent = target; return; }
        const start = performance.now();
        const duration = 1250;
        const tick = now => {
          const pct = Math.min(1, (now - start) / duration);
          counter.textContent = Math.round(target * (1 - Math.pow(1 - pct, 3)));
          if (pct < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };
      if ('IntersectionObserver' in window) {
        const countObserver = new IntersectionObserver(entries => entries.forEach(e => { if(e.isIntersecting){ runCounter(); countObserver.disconnect(); } }), {threshold:.35});
        counter.textContent = '0';
        countObserver.observe(counter);
      } else runCounter();
    }

    const rail = root.querySelector('[data-mlx-rail]');
    root.querySelectorAll('[data-mlx-scroll]').forEach(btn => btn.addEventListener('click', () => {
      if (!rail) return;
      const amount = Math.max(320, rail.clientWidth * .72) * (btn.dataset.mlxScroll === 'prev' ? -1 : 1);
      rail.scrollBy({left:amount, behavior:'smooth'});
    }));

    const easter = root.querySelector('[data-mlx-easter]');
    const releaseLegacyBodyLock = () => {
      if (document.body.style.overflow === 'hidden' && (!easter || easter.hidden)) {
        document.body.style.overflow = '';
      }
    };
    const openEaster = () => {
      if (!easter) return;
      releaseLegacyBodyLock();
      easter.hidden = false;
      easter.setAttribute('aria-hidden', 'false');
      easter.querySelector('.mlx-easter__close')?.focus({preventScroll:true});
    };
    const closeEaster = () => {
      if (!easter) return;
      easter.hidden = true;
      easter.setAttribute('aria-hidden', 'true');
      releaseLegacyBodyLock();
    };
    root.querySelectorAll('[data-mlx-easter-open]').forEach(btn => btn.addEventListener('click', openEaster));
    root.querySelectorAll('[data-mlx-easter-close]').forEach(btn => btn.addEventListener('click', closeEaster));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && easter && !easter.hidden) closeEaster(); });
    const reconcileMobileScrollState = () => {
      if (window.innerWidth >= 990) return;
      if (!easter || easter.hidden) releaseLegacyBodyLock();
      document.querySelectorAll('header-drawer').forEach(drawer => {
        const details = drawer.querySelector('details[open]');
        if (!details) return;
        if (typeof drawer.close === 'function') drawer.close();
        else details.removeAttribute('open');
      });
      document.querySelectorAll('dialog-component').forEach(component => {
        const dialog = component.querySelector('dialog[open].dialog-closing');
        if (dialog && typeof component.closeDialog === 'function') component.closeDialog();
      });
    };

    window.addEventListener('pageshow', event => {
      releaseLegacyBodyLock();
      if (event.persisted) window.setTimeout(reconcileMobileScrollState, 0);
    });
    window.addEventListener('pagehide', () => {
      if (easter && !easter.hidden) closeEaster();
      else releaseLegacyBodyLock();
    });
    window.addEventListener('orientationchange', () => window.setTimeout(reconcileMobileScrollState, 150));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) reconcileMobileScrollState();
    });

    const heroSeal = document.querySelector('.ml2-hero__seal');
    if (heroSeal) {
      heroSeal.setAttribute('role','button');
      heroSeal.setAttribute('tabindex','0');
      heroSeal.setAttribute('aria-label','Open Montani Semper Liberi story');
      heroSeal.style.cursor = 'pointer';
      heroSeal.addEventListener('click', openEaster);
      heroSeal.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openEaster(); } });
    }

    const player = document.querySelector('[data-co-audio-player]');
    const audio = player?.querySelector('[data-audio-element]');
    const now = root.querySelector('[data-mlx-now]');
    const jump = root.querySelector('[data-mlx-player-jump]');
    const playButton = player?.querySelector('[data-audio-play]');
    const state = player?.querySelector('[data-audio-state]');
    const featuredLabel = player?.querySelector('.co-audio-player__track-copy small');
    if (featuredLabel) featuredLabel.textContent = 'FEATURED FULL TRACK';

    const scrollPlayer = () => player?.scrollIntoView({behavior:'smooth', block:'center'});
    now?.addEventListener('click', scrollPlayer);
    jump?.addEventListener('click', () => { scrollPlayer(); window.setTimeout(() => { if (audio?.paused) playButton?.click(); }, 450); });

    if (audio) {
      let saved = Number(sessionStorage.getItem('cecilBackboneTime') || 0);
      const save = () => {
        if (Number.isFinite(audio.currentTime) && audio.currentTime > 1) sessionStorage.setItem('cecilBackboneTime', String(audio.currentTime));
      };
      audio.addEventListener('loadedmetadata', () => {
        if (saved > 4 && saved < audio.duration - 4) {
          audio.currentTime = saved;
          if (state) state.textContent = 'Resume';
        }
      }, {once:true});
      let lastSecond = -1;
      audio.addEventListener('timeupdate', () => {
        const sec = Math.floor(audio.currentTime || 0);
        if (sec !== lastSecond) { lastSecond = sec; save(); }
      });
      audio.addEventListener('play', () => { if (now) now.hidden = false; });
      audio.addEventListener('pause', () => { save(); if (now && audio.currentTime < 1) now.hidden = true; });
      audio.addEventListener('ended', () => { sessionStorage.removeItem('cecilBackboneTime'); saved = 0; if (now) now.hidden = true; });
      window.addEventListener('pagehide', save);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
